"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _functions = require("../functions");

var FlagIcon = function FlagIcon(React, options, styles) {
  return function (props) {
    var _props$Component = props.Component,
        Component = _props$Component === void 0 ? 'span' : _props$Component,
        children = props.children;
    return React.createElement(Component, {
      className: (0, _functions.makeClassnames)(props, options, styles)
    }, children);
  };
};

var _default = FlagIcon;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/FlagIcon/FlagIcon.js
// module id = 336
// module chunks = 168707334958949